var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgView = function SvgView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#818CF8",
    d: "M15.898 8.52C15.755 8.323 12.35 3.73 8 3.73S.244 8.324.102 8.52a.53.53 0 0 0 0 .623C.244 9.337 3.65 13.929 8 13.929s7.755-4.592 7.898-4.787a.53.53 0 0 0 0-.623M8 12.873c-3.204 0-5.98-3.048-6.8-4.044.82-.997 3.589-4.044 6.8-4.044 3.204 0 5.979 3.048 6.8 4.045-.82.997-3.59 4.043-6.8 4.043"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#818CF8",
    d: "M8 5.665A3.17 3.17 0 0 0 4.835 8.83 3.17 3.17 0 0 0 8 11.995a3.17 3.17 0 0 0 3.165-3.165A3.17 3.17 0 0 0 8 5.665m0 5.275a2.11 2.11 0 0 1-2.11-2.11c0-1.164.946-2.11 2.11-2.11s2.11.946 2.11 2.11-.947 2.11-2.11 2.11"
  })));
};
export default SvgView;